import {useQuery} from "@tanstack/react-query";
import * as catalogApi from "../services/catalog.api";

export const useCategories = () =>
	useQuery({
		queryKey: ["categories"],
		queryFn: catalogApi.getCategories,
		select: (data) => data.categories,
	});

export const useTrees = () =>
	useQuery({
		queryKey: ["trees"],
		queryFn: catalogApi.getTrees,
		select: (data) => data.trees,
	});

export const useColors = () =>
	useQuery({
		queryKey: ["colors"],
		queryFn: catalogApi.getColors,
		select: (data) => data.colors,
	});

export const useSets = (categoryId) =>
	useQuery({
		queryKey: ["sets", categoryId],
		queryFn: () => catalogApi.getSets(categoryId),
		enabled: !!categoryId,
		select: (data) => data.sets,
	});

export const useFurnitures = (setId) =>
	useQuery({
		queryKey: ["furnitures", setId],
		queryFn: () => catalogApi.getFurnitures(setId),
		enabled: !!setId,
		select: (data) => data.furnitures,
	});
